import { SystemAccountAction } from '@/redux/actions/systemAccount/constant';

// 权限组
export interface RoleGroupInfo {
  key: string; // id
  value: string; // 名称
}

// 账户
export interface SystemAccountInfo {
  id: number; // 用户id
  employeeNo: string; // 员工编号
  name: string; // 用户姓名
  mobileAreaCode: string; // 手机号区号
  mobile: string; // 用户手机号
  authGroup: string; // 权限组
  status: 0 | 1; // 状态 0禁用 1启用
  expireDate?: number; // 有效期
  password?: string; // 密码
}

export interface ReducerState {
  loadingStatus: boolean; // 页面加载状态
  roleGroupList: RoleGroupInfo[]; // 权限组列表
  accountList: SystemAccountInfo[]; // 账户列表
}

const initState: ReducerState = {
  loadingStatus: true,
  accountList: [],
  roleGroupList: [],
};

// action handler
type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;
const reducerMap = {
  [SystemAccountAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return {
      ...state,
      loadingStatus: payload,
    };
  }),
  [SystemAccountAction.setRoleGroupList]: <ActionHandler<RoleGroupInfo[]>>((state, { payload }) => {
    return {
      ...state,
      roleGroupList: payload,
    };
  }),
  [SystemAccountAction.setAccountList]: <ActionHandler<SystemAccountInfo[]>>((
    state,
    { payload },
  ) => {
    return {
      ...state,
      accountList: payload,
    };
  }),
};

export const reducerMapper = (state = initState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(state, action);
  }
  return state;
};

export const storeName = 'systemAccountManagement';
